var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text-center"},[_c('b-spinner',{attrs:{"variant":"primary"}}),_c('br'),_vm._v(" Načítání.. ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }